export function isTriviaEngagement(
  engagement?: { type?: string | null } | null,
): boolean {
  return engagement?.type === 'TRIVIA';
}

/** Pill titles longer than this render as "Trivia"; lobby shows the full title. */
export const TRIVIA_TITLE_PILL_MAX_CHARS = 24;

export function triviaJoinBubbleText(engagementTitle?: string | null): string {
  const title = engagementTitle ?? '';
  if (title.length > TRIVIA_TITLE_PILL_MAX_CHARS) {
    return 'Trivia';
  }
  return title;
}

export function triviaPlayersInLabel(count: number): string {
  if (count <= 0) return 'Waiting for players';
  return count === 1 ? '1 player in' : `${count} players in`;
}

export function triviaAnswersInLabel(count: number): string {
  return count === 1 ? '1 answer in' : `${count} answers in`;
}

/**
 * Reveal copy is about this question's answers, not lobby occupancy.
 * Mixing "23 of 48 got it right" with "52 players in" looked like a
 * counting error (48 ≠ 52); unanswered players are simply omitted.
 */
export function triviaRevealResultLabel(
  correct: number,
  answered: number,
): string {
  if (answered <= 0) return 'No one answered this one';
  if (answered === 1) return `${correct} of 1 answer was correct`;
  return `${correct} of ${answered} answers were correct`;
}

export function triviaPlayersKickerLabel(count: number): string {
  return count === 1 ? '1 player' : `${count} players`;
}

/** 28-character engagement title that used to clip Stage chrome. */
export const TRIVIA_LONG_STAGE_TITLE = 'QA179 prod smoke (delete me)';

export const TRIVIA_STAGE_LONG_TITLE_FRAMES = [
  'stage-idle',
  'stage-open',
  'stage-closed',
  'stage-revealed',
  'stage-skipped',
] as const;

export const TRIVIA_STAGE_LAYOUT_FRAMES = [
  'stage-idle',
  'stage-open',
  'stage-open-long',
  'stage-open-max',
  'stage-skipped',
  'stage-closed',
  'stage-revealed',
  'stage-revealed-long',
  'stage-revealed-max',
  'stage-complete',
  'stage-complete-co',
] as const;

export function triviaStageIsSkipped(
  view?: {
    skipped?: boolean | null;
    status?: string | null;
  } | null,
): boolean {
  if (!view?.skipped) return false;
  return view.status === 'QUESTION_CLOSED';
}
